export default {
  app: {
    name: 'APAC Status',
    search_placeholder: 'Search accounts, users, monitors…',
    search_palette_placeholder: 'Search accounts, users, monitors, status pages, maintenance…',
    search_hint_min_chars: 'Type at least 2 characters to search',
    search_loading: 'Searching…',
    search_no_results: 'No results found',
    keyboard_hint: '⌘K',
    search: {
      sections: {
        account: 'Accounts',
        user: 'Users',
        monitor: 'Monitors',
        status_page: 'Status pages',
        maintenance: 'Maintenance',
      },
    },
    actions: {
      sign_out: 'Sign out',
      switch_account: 'Switch account',
      invite_user: 'Invite user',
      create_account: 'Create account',
      save: 'Save',
      cancel: 'Cancel',
    },
    create_menu: {
      title: 'Create',
      account: 'Create account',
      user: 'Invite user',
      monitor: 'New monitor',
      status_page: 'New status page',
      maintenance: 'New maintenance window',
    },
  },
  nav: {
    dashboard: 'Home',
    monitors: 'Monitors',
    incidents: 'Incidents',
    maintenance: 'Maintenance',
    status_pages: 'Status pages',
    reports: 'Reports',
    audit_log: 'Audit log',
    settings: 'Settings',
    admin_accounts: 'Accounts',
    admin_users: 'Users',
    admin_dashboard: 'Overview',
    users: 'Users',
  },
  admin_dashboard: {
    title: 'Platform Overview',
    subtitle: 'Aggregated health across all accounts.',
    metrics: {
      total_accounts: 'Total accounts',
      total_monitors: 'Total monitors',
      active_incidents: 'Active incidents',
      uptime_24h: 'Uptime (24h)',
    },
    health: {
      title: 'Monitor health',
      operational: 'Operational',
      degraded: 'Degraded',
      down: 'Down',
      paused: 'Paused',
      total: 'Total',
    },
    active_incidents: {
      title: 'Active incidents',
      empty_title: 'No active incidents',
      empty_description: 'All monitors across all accounts are healthy.',
    },
    accounts: {
      title: 'Accounts',
    },
  },
  monitors: {
    list: {
      title: 'Monitors',
      subtitle: 'HTTP monitor list and uptime overview.',
    },
    form: {
      url: 'URL to monitor',
      tags: 'Tags',
      notify: 'How to notify',
      interval: 'Monitor interval',
      timeout: 'Request timeout',
      ssl: 'SSL certificate and Domain checks',
    },
    detail: {
      current_status: 'Current status',
      last_check: 'Last check',
      last_24h: 'Last 24 hours',
      response_time: 'Response time',
      activity_log: 'Activity log',
    },
  },
  dashboard: {
    title: 'Home',
    subtitle: "Overview of {account}'s monitors and incidents.",
    actions: {
      view_status_page: 'View status page',
      add_monitor: 'Add monitor',
      refresh: 'Refresh',
    },
    metrics: {
      uptime_24h: 'Uptime (24h)',
      avg_latency: 'Average latency',
      active_incidents: 'Active incidents',
      mtbf_24h: 'MTBF (24h)',
      over_n_monitors: 'over {count}',
      incidents_24h: '{count} in 24h',
    },
    health: {
      title: 'Monitor health',
      operational: 'Operational',
      degraded: 'Degraded',
      down: 'Down',
      paused: 'Paused',
      total: 'Total',
    },
    recent_incidents: {
      title: 'Recent incidents',
      view_all: 'View all',
      empty_title: 'No recent incidents',
      empty_description: "When monitors fail you'll see them here.",
    },
    recent_monitors: {
      title: 'Monitors',
      view_all: 'View all',
      empty_title: 'No monitors yet',
      empty_description: 'Add your first monitor to start tracking uptime.',
    },
  },
  auth: {
    sign_in: 'Sign in to APAC Status',
    email: 'Email',
    password: 'Password',
    submit: 'Continue',
    forgot_password: 'Forgot password?',
    two_factor_title: 'Two-factor authentication',
    two_factor_hint: 'Enter the 6-digit code from your authenticator app.',
    forgot_password_title: 'Reset your password',
    forgot_password_hint: "Enter your email and we'll send you a link.",
    forgot_password_submit: 'Send reset link',
    set_password_title: 'Set your password',
    set_password_hint: 'Choose a password to finish setting up your account.',
    new_password: 'New password',
    submit_set_password: 'Set password',
    no_signup: 'Sign-up is disabled — contact your administrator for access.',
  },
  empty: {
    no_data: 'No data yet',
    no_data_hint: 'This view is intentionally empty in the skeleton.',
  },
  errors: {
    generic: 'Something went wrong.',
    unauthorized: 'You need to sign in.',
    forbidden: 'You do not have permission for that.',
  },
};
